module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-logo.png?h=2c0bfe3c9d88a22f91e5ce5a432bc18c";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-logo.png
// module id = 2097
// module chunks = 12 15